module.exports = __webpack_public_path__ + "static/img/rbg.38e1ccc2.png";